import { useSubscription } from '../../utils';
import { toaster } from './Toaster';

export function useToaster() {
    useSubscription(toaster.subscribe, []);

    return toaster;
}
